export default __webpack_public_path__ + "static/media/logo_pwa.4d163b7b.png";